import { render, staticRenderFns } from "./TypographyHighlightSection.vue?vue&type=template&id=47cd87cf"
import script from "./TypographyHighlightSection.vue?vue&type=script&lang=ts"
export * from "./TypographyHighlightSection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyHighlightSection.vue?vue&type=style&index=0&id=47cd87cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports